export const baseUrl = 'https://api.themoviedb.org/3/'
export const API_KEY = "011197be68c0deda335db4bb9ec3df65"
export const imageUrl = "https://image.tmdb.org/t/p/original"